const locale = {
  layout_list_result: '{total} {total:Result/Results}',
  layout_list_selectedTotal: '( {selectedTotal} {selectedTotal:Result/Results} selected )',
  layout_basic_header_howTo: 'How to?',
  layout_basic_header_whatIs: "What's this?"
};
export default locale;